import React from 'react';

import { ClickableIcon } from '../ClickableIcon';
import { IconCloseSkinny as IconClose } from '../../icons/colorless';

import { i18n } from './ClearButton.i18n';
import type { ClearButtonProps } from './types';

/* TODO DIRECT-222878 Починить переход по Tab в Safari (он не работал и ранее) */
export const ClearButton = (props: ClearButtonProps) => {
    const clearButtonText = i18n('Очистить');
    return (
        <ClickableIcon
            className={props.className}
            onClick={props.onClick}
            isDisabled={props.isDisabled}
            preventFocusOnPress={props.keepFocusOnClearButton}
            tabIndex={0}
            color="current"
            title={clearButtonText}
            aria-label={clearButtonText}
            data-testid={props['data-testid'] ? `${props['data-testid']}.Clear` : undefined}
            logNode="ClearButton"
        >
            <IconClose size={props.size} />
        </ClickableIcon>
    );
};
